import { ContractConceptRelationshipState } from '../../states/ContractConceptRelationship.State';
import { ContractConceptRelationship } from '../../../models/Entities/Contracts/ContractConceptRelationship';
import * as actions from '../../actions/ContractConceptRelationship.Actions';

import { ContractConceptRelationshipUnloadState } from '../../states/ContractConceptRelationship.State';

export default function ContractConceptRelationshipUpdateReducer(
  state: ContractConceptRelationshipState | undefined,
  action: any
): ContractConceptRelationshipState {
  const currentState = state ?? ContractConceptRelationshipUnloadState;
  switch (action.type) {
    case actions.CONTRACT_CONCEPT_REL_UPDATE_REQUEST:
      return {
        ...currentState,
        isUpdatingOne: true,
        successUpdatingOne: undefined,
        failOnUpdatingOne: false,
        error: undefined,
      };
    case actions.CONTRACT_CONCEPT_REL_UPDATE_SUCCESS:

      var FormName = action.relationship[0]?.formConcept || '';

      var filteredList = currentState?.list?.filter((item: ContractConceptRelationship) => item.formConcept !== FormName ) || [];

      var updateList = [...filteredList, ...action.relationship];

      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: true,
        failOnUpdatingOne: false,
        list: updateList
      };
    case actions.CONTRACT_CONCEPT_REL_UPDATE_FAILURE:
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: false,
        failOnUpdatingOne: true,
        error: action.error,
      };
    default:
      return currentState;
  }
}
